import EmailIcon from '@mui/icons-material/Email';
import { Theme, useMediaQuery } from '@mui/material';
import Grid from '@mui/material/Grid';
import { ArrayField, ArrayInput, Create, Datagrid, Edit, EditButton, FormTab, List, ReferenceManyField, SelectInput, Show, ShowActions, SimpleFormIterator, SimpleList, SimpleShowLayout, TabbedForm, TextField, TextInput, required, usePermissions, useResourceDefinition } from 'react-admin';
import { useParams } from 'react-router-dom';
import AddOne2ManyButton from 'utils/react-admin/AddOne2ManyButton';
import DateFnsField from 'utils/react-admin/DateFnsField';
import GridWrapper from 'utils/react-admin/GridWrapper';
import XlsHtmlExporter from 'utils/react-admin/exporters/XlsHtml';
import HtmlField from 'utils/react-admin/fields/HtmlField';
import DateRangeFilterInput from 'utils/react-admin/filters/DateRangeFilterInput';
import RichTextInputEx from 'utils/react-admin/inputs/RichTextInputEx';
import { Permissions } from '../../ra-php-crud-api-auth';

export const CHOICES_EMAIL_TEMPLATE_FOOTER_TYPE = [
  { id: 'by_default', name: 'by_default', },
  { id: 'custom', name: 'custom', },
  { id: 'disable', name: 'disable', },
];

export const CHOICES_EMAIL_TEMPLATE_ACTIVE_STATUS = [
  { id: 'enabled', name: 'enabled', },
  { id: 'disabled', name: 'disabled', },
];

export const CHOICES_EMAIL_TEMPLATE_CC_EMAIL_TYPE = [
  { id: 'append', name: 'append', },
  { id: 'overwrite', name: 'overwrite', },
];

export const CHOICES_EMAIL_TEMPLATE_BCC_EMAIL_TYPE = [
  { id: 'append', name: 'append', },
  { id: 'overwrite', name: 'overwrite', },
];
// const RESOURCE_FIELDS = {}
const ResourceFilters = [
  <TextInput source="search" alwaysOn />,
  <TextInput source="alias" fullWidth />,
  <TextInput source="title" fullWidth />,
  <TextInput source="subject_en" fullWidth />,
  <TextInput source="subject_tc" fullWidth />,
  <TextInput source="subject_sc" fullWidth />,
  <TextField source="content_en_html" fullWidth />,
  <TextField source="content_tc_html" fullWidth />,
  <TextField source="content_sc_html" fullWidth />,
  <SelectInput source="footer_type" fullWidth choices={CHOICES_EMAIL_TEMPLATE_FOOTER_TYPE} />,
  <TextField source="footer_en_html" fullWidth />,
  <TextField source="footer_tc_html" fullWidth />,
  <TextField source="footer_sc_html" fullWidth />,
  <SelectInput source="active_status" fullWidth choices={CHOICES_EMAIL_TEMPLATE_ACTIVE_STATUS} />,
  <TextInput source="sender_name" fullWidth />,
  <TextInput source="sender_email" fullWidth />,
  <TextInput source="reply_to_email" fullWidth />,
  <SelectInput source="cc_email_type" fullWidth choices={CHOICES_EMAIL_TEMPLATE_CC_EMAIL_TYPE} />,
  <SelectInput source="bcc_email_type" fullWidth choices={CHOICES_EMAIL_TEMPLATE_BCC_EMAIL_TYPE} />,
  <DateRangeFilterInput source="created" fullWidth />,
  <TextInput source="createdBy" fullWidth />,
  <DateRangeFilterInput source="updated" fullWidth />,
  <TextInput source="updatedBy" fullWidth />,
];

const validateAlias: any[] = [];
const validateTitle: any[] = [];
const validateSubjectEn: any[] = [];
const validateSubjectTc: any[] = [];
const validateSubjectSc: any[] = [];
// const validateContentEnHtml: any[] = [];
// const validateContentTcHtml: any[] = [];
// const validateContentScHtml: any[] = [];
const validateFooterType: any[] = [required()];
// const validateFooterEnHtml: any[] = [required()];
// const validateFooterTcHtml: any[] = [required()];
// const validateFooterScHtml: any[] = [required()];
const validateActiveStatus: any[] = [required()];
const validateSenderName: any[] = [];
const validateSenderEmail: any[] = [];
const validateReplyToEmail: any[] = [];
const validateCcEmailType: any[] = [required()];
// const validateCcEmailArray: any[] = [];
const validateBccEmailType: any[] = [required()];
// const validateBccEmailArray: any[] = [];

export const ResourceList = () => {
  const isSmall = useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));

  return (
    <List filters={ResourceFilters} sort={{ field: 'created', order: 'DESC' }} exporter={XlsHtmlExporter}>
      {isSmall ? (
        <SimpleList linkType="edit"
          primaryText={(record: any) => `${record.title} (#${record.id})`}
        ></SimpleList>)
        : (
          <Datagrid>
            <TextField source="id" />
            <TextField source="alias" fullWidth />
            <TextField source="title" fullWidth />
            {/* <HtmlField source="content_en_html" fullWidth showButton />
            <HtmlField source="content_tc_html" fullWidth showButton />
            <HtmlField source="content_sc_html" fullWidth showButton /> */}
            {/* <TextField source="footer_type" fullWidth /> */}
            {/* <HtmlField source="footer_en_html" fullWidth showButton />
            <HtmlField source="footer_tc_html" fullWidth showButton />
            <HtmlField source="footer_sc_html" fullWidth showButton /> */}
            <TextField source="active_status" fullWidth />
            <TextField source="sender_name" fullWidth />
            {/* <TextField source="cc_email_type" fullWidth /> */}
            {/* <ArrayField source="cc_email_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField> */}
            {/* <TextField source="bcc_email_type" fullWidth /> */}
            {/* <ArrayField source="bcc_email_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField> */}
            <DateFnsField source="created" />
            <DateFnsField source="updated" />
            {/* <ShowButton /> */}
            <EditButton />
          </Datagrid>)
      }
    </List>
  )
};

export const ResourceShow = () => {
  const { isLoading, permissions } = usePermissions<Permissions>();
  const { hasEdit } = useResourceDefinition();

  if (isLoading || undefined === permissions) { return (<>Loading</>); }

  return (
    <Show actions={hasEdit ? <ShowActions /> : <></>}>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="alias" fullWidth />
        <TextField source="title" fullWidth />
        <TextField source="subject_en" fullWidth />
        <TextField source="subject_tc" fullWidth />
        <TextField source="subject_sc" fullWidth />
        <HtmlField source="content_en_html" fullWidth />
        <HtmlField source="content_tc_html" fullWidth />
        <HtmlField source="content_sc_html" fullWidth />
        <TextField source="footer_type" fullWidth />
        <HtmlField source="footer_en_html" fullWidth />
        <HtmlField source="footer_tc_html" fullWidth />
        <HtmlField source="footer_sc_html" fullWidth />
        <TextField source="active_status" fullWidth />
        <TextField source="sender_name" fullWidth />
        <TextField source="sender_email" fullWidth />
        <TextField source="reply_to_email" fullWidth />
        <TextField source="cc_email_type" fullWidth />
        <ArrayField source="cc_email_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField>
        <TextField source="bcc_email_type" fullWidth />
        <ArrayField source="bcc_email_array"><SimpleFormIterator><TextField source="text" /></SimpleFormIterator></ArrayField>
        <DateFnsField source="created" />
        <DateFnsField source="updated" />
      </SimpleShowLayout>
    </Show>
  )
};

const transform = (data: any) => {
  console.log('transform', data);
  data.cc_email_array = null === data.cc_email_array ? null : JSON.stringify(data.cc_email_array);
  data.bcc_email_array = null === data.bcc_email_array ? null : JSON.stringify(data.bcc_email_array);
  return data;
};

export const ResourceForm = ({ isEdit }: { isEdit?: boolean }) => {
  // const { getMany } = useDataProvider();
  const { ref, ref_id, ref_default_values } = useParams();
  // const redirect = ref_id ? `/${ref}/${ref_id}` : undefined;
  const defaultValueRefId = ref_id ? { [`${ref}_id`]: ref_id } : {};
  const refDefaultValues = ref_default_values ? JSON.parse(ref_default_values as string) : {};

  return (
    <TabbedForm
      defaultValues={{ ...defaultValueRefId, ...refDefaultValues }}
    >
      {/* redirect={redirect} */}
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={6}><TextInput source="alias" disabled fullWidth validate={validateAlias} /></Grid>
          <Grid item xs={6}><TextInput source="title" disabled fullWidth validate={validateTitle} /></Grid>
          <Grid item xs={4}><TextInput source="subject_en" fullWidth validate={validateSubjectEn} /></Grid>
          <Grid item xs={4}><TextInput source="subject_tc" fullWidth validate={validateSubjectTc} /></Grid>
          <Grid item xs={4}><TextInput source="subject_sc" fullWidth validate={validateSubjectSc} /></Grid>
        </GridWrapper>
        <RichTextInputEx source="content_en_html" />
        <RichTextInputEx source="content_tc_html" />
        <RichTextInputEx source="content_sc_html" />
      </FormTab>
      <FormTab label="ra.page.general">
        <SelectInput source="footer_type" fullWidth choices={CHOICES_EMAIL_TEMPLATE_FOOTER_TYPE} validate={validateFooterType} />
        <RichTextInputEx source="footer_en_html" />
        <RichTextInputEx source="footer_tc_html" />
        <RichTextInputEx source="footer_sc_html" />
      </FormTab>
      <FormTab label="ra.page.general">
        <GridWrapper>
          <Grid item xs={12}><SelectInput source="active_status" fullWidth choices={CHOICES_EMAIL_TEMPLATE_ACTIVE_STATUS} validate={validateActiveStatus} /></Grid>
          <Grid item xs={6}><TextInput source="sender_name" fullWidth validate={validateSenderName} /></Grid>
          <Grid item xs={6}><TextInput source="sender_email" fullWidth validate={validateSenderEmail} /></Grid>
          <Grid item xs={12}><TextInput source="reply_to_email" fullWidth validate={validateReplyToEmail} /></Grid>
          <Grid item xs={3}><SelectInput source="cc_email_type" fullWidth choices={CHOICES_EMAIL_TEMPLATE_CC_EMAIL_TYPE} validate={validateCcEmailType} /></Grid>
          <Grid item xs={9}><ArrayInput source="cc_email_array"><SimpleFormIterator sx={{ "& .RaSimpleFormIterator-form": { width: "100%" } }}><TextInput source="text" fullWidth /></SimpleFormIterator></ArrayInput></Grid>
          <Grid item xs={3}><SelectInput source="bcc_email_type" fullWidth choices={CHOICES_EMAIL_TEMPLATE_BCC_EMAIL_TYPE} validate={validateBccEmailType} /></Grid>
          <Grid item xs={9}><ArrayInput source="bcc_email_array"><SimpleFormIterator sx={{ "& .RaSimpleFormIterator-form": { width: "100%" } }}><TextInput source="text" fullWidth /></SimpleFormIterator></ArrayInput></Grid>
        </GridWrapper>
      </FormTab>
      <FormTab label="Email Log">
        <AddOne2ManyButton basepath="email_log" label="Add" defaultValues={{}} />
        <ReferenceManyField
          reference="email_log"
          target="email_template_id"
          fullWidth
        >
          <Datagrid>
            <EditButton />
          </Datagrid>
        </ReferenceManyField>
      </FormTab>
    </TabbedForm>
  )
}

export const ResourceCreate = () => {
  return (
    <Create mutationMode="pessimistic" transform={transform}>
      <ResourceForm />
    </Create>
  )
};

export const ResourceEdit = () => {
  return (
    <Edit mutationMode="pessimistic" transform={transform}>
      <ResourceForm isEdit={true} />
    </Edit>
  )
};

const Resource = {
  list: ResourceList,
  edit: ResourceEdit,
  create: ResourceCreate,
  // show: ResourceShow,
  icon: EmailIcon,
}

export default Resource;
